import { createPortal } from 'react-dom';

import { cx, forwardRef, julo } from '@julo-ui/react';
import callAllFn from '@julofinance/web-helpers/dist/fn/callAllFn';

import { useDelayUnmount } from '@hooks';
import { useHandleOnOpen } from './usecase';
import { fadeIn, fadeOut } from './animation';
import { DialogProps } from './types';
import { dialogCx, dialogOverlayCx } from './styles';

const Dialog = forwardRef<DialogProps, 'div'>((props, ref) => {
  const {
    isOpen,
    onClose,
    sx,
    className,
    children,
    onClick,
    isCloseOnOverlayClick = true,
    fullScreen = false,
    ...resProps
  } = props;

  const isShouldRender = useDelayUnmount({
    isMounted: isOpen,
    delay: 200,
  });

  useHandleOnOpen({ isOpen });

  return createPortal(
    isShouldRender && (
      <julo.div
        className='dialog__overlay'
        sx={{
          animation: `${isOpen ? fadeIn : fadeOut} 0.2s forwards`,
        }}
        onClick={isCloseOnOverlayClick ? onClose : undefined}
        __css={dialogOverlayCx}
      >
        <julo.div
          {...resProps}
          ref={ref}
          sx={{
            ...sx,
            animation: `${isOpen ? fadeIn : fadeOut} 0.2s forwards`,
          }}
          data-fullscreen={fullScreen}
          open={isOpen}
          onClick={callAllFn((e: MouseEvent) => e.stopPropagation(), onClick)}
          __css={dialogCx}
          className={cx('dialog', className)}
        >
          {children}
        </julo.div>
      </julo.div>
    ),
    document.body,
  );
});

export default Dialog;
